import {
  RIconCamera,
  RIconDocument,
  RIconPC,
  RIconPencil,
  RIconPolice,
  RIconUser,
  RIconWarning,
  RIconWatch,
} from "../../components/Icons";
import { RIconRRB } from "../../components/Icons/RIconRRB";
export const iconArray = [
  { id: 28, icon: <RIconWatch width={16} height={16} className="text-primary" /> },
  { id: 29, icon: <RIconPC width={16} height={16} className="text-primary"/> },
  { id: 32, icon: <RIconWatch width={16} height={16} className="text-primary"/> },
  { id: 36, icon: <RIconCamera width={16} height={16} className="text-primary"/> },
  { id: 37, icon: <RIconUser width={16} height={16} className="text-primary"/> },
  { id: 43, icon: <RIconUser width={16} height={16} className="text-primary"/> },
  { id: 44, icon: <RIconUser width={16} height={16} className="text-primary"/> },
  { id: 45, icon: <RIconRRB width={16} height={16} className="text-primary"/> },
  { id: 52, icon: <RIconDocument width={16} height={16} className="text-primary"/> },
  { id: 53, icon: <RIconWarning width={16} height={16} className="text-primary"/> },
  { id: 57, icon: <RIconDocument width={16} height={16} className="text-primary"/> },
  { id: 63, icon: <RIconPolice width={16} height={16} className="text-primary"/> },
  { id: 64, icon: <RIconPolice width={16} height={16} className="text-primary"/> },
  { id: 65, icon: <RIconDocument width={16} height={16} className="text-primary"/> },
  { id: 66, icon: <RIconDocument width={16} height={16} className="text-primary"/> },
  { id: 67, icon: <RIconDocument width={16} height={16} className="text-primary"/> },
  { id: 68, icon: <RIconPC width={16} height={16} className="text-primary"/> },
  { id: 69, icon: <RIconPencil width={16} height={16} className="text-primary"/> },
];
